import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SyncApi } from "apis/SyncApi";
import { GeneralSync } from "models/dbModels/syncSettings/ManagedStockSyncSettings";


export const generalSync = createAsyncThunk("syncSlice/generalSync", async (payload: GeneralSync) => {
    const response = await SyncApi.SyncChanges(payload);
    return response.data;
});

export type InitialStateType = {
};

const initialState: InitialStateType = {
};

const syncSlice = createSlice({
    name: "syncSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
    },
    extraReducers: (builder) => {
    }
});

export const { } = syncSlice.actions

export default syncSlice.reducer;